module.exports = __webpack_public_path__ + "80deee247ea102b71f117e544e7f3f64.svg";